import { normalizeString } from "@jasper/shared";

import { ProductCategory } from "./product";

/**
 * Returns the categories whose products match the query, keeping only the
 * matching products inside each category. A product matches on its label or
 * its description, ignoring case and accents. Categories left without any
 * product are dropped. An empty query returns the catalog untouched.
 */
export const filterCatalog = (
  categories: ProductCategory[],
  query: string
): ProductCategory[] => {
  const term = normalizeString(query.trim());
  if (!term) return categories;

  return categories
    .map(category => ({
      ...category,
      choices: category.choices.filter(choice =>
        normalizeString(`${choice.label} ${choice.description}`).includes(term)
      ),
    }))
    .filter(category => category.choices.length > 0);
};
